module.exports = __webpack_public_path__ + "img/tanos.0400d82a.webp";